import camelCase from 'lodash/camelCase';

// Utility class for handling fee-related operations like filtering, mapping and checking fee codes
class FeeUtil {
	// Filters cost details by fee codes and calculates total fees.
	static filterByFeeCodesAndCalculateTotal({
		costDetails = {},
		feeCodes = {},
	}) {
		const feeCodesArray = Object.values(feeCodes);
		const filteredByFeeCode = Object.values(costDetails).filter(
			fee => feeCodesArray.includes(fee.feeCode) && fee.cost > 0
		);
		const totalFees = filteredByFeeCode.reduce((sum, fee) => sum + fee.cost, 0);

		return {
			filteredCostDetails: filteredByFeeCode,
			totalFees,
		};
	}

	// Checks if any of the specified fee codes exist in the cost details array
	static hasFeeCodes({ costDetails = {}, feeCodes = {} }) {
		const feeCodesArray = Object.values(feeCodes);

		return Object.values(costDetails).some(
			detail => feeCodesArray.includes(detail.feeCode) && detail.cost > 0
		);
	}

	// Converts an array of fee details into an object with camelCase keys.
	static feeDetailsMap({ feeDetails = [] }) {
		return feeDetails.reduce(
			(acc, detail) => ({
				...acc,
				// Create new property using camelCase version of feeCode as key
				[camelCase(detail.feeCode)]: detail,
			}),
			{}
		);
	}
}

export default FeeUtil;
